import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../core'

export const ChaveAgendaOnlineField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.chaveAgendaOnline} parse={onlyNumbers} {...props} />
}
